
export interface IGetNodeParameters {
    TreeNodeModelItem: [ITreeNodeModelItem];
    PageNumber: number;
    PageSize: number;
    TotalRow: number;
    HasMoreNodes: boolean;
}
export interface IGetVendorNodeParameters extends IGetNodeParameters {
    // TreeNodeModelItem: IVendorTreeModeItem;
}
export interface ITreeNodeModelItem {
    ID: number;
    Name: string;
    TypeID: number;
    TypeName: string;
    NodeIndex?: string;
    Icon: string;
    processValue?: number;
    Children?: [ITreeNodeModelItem];
    HasChild: boolean;
    TreeStatus: boolean;
    IsOpen?: boolean;
    IsLoad?: boolean;
    AjaxLoading?: boolean;
    Processing?: boolean;
    SalableItem?: {
        OptionName: string,
        Price: number,
        SalableItemID: number
    },
    TotalRow: number;
    PageNumber: number;
    PageSize: number;
    HasMoreNodes: boolean;
}
export interface IVendorTreeModeItem extends ITreeNodeModelItem {
    Wage: number;
    Children?: [IVendorTreeModeItem];
    CommisionPrice?: number

}
export interface IPublishParameters {
    Guid: string;
}

export interface ITreeNodeSendParams {
    ID: number;
    TypeID: number;
}

export interface IPublishSendParams {
    TypeID: number;
    Idies: number[];
    IsInsertMode: boolean;
}

export interface IgetProgressSendParams {
    Guid: string;
}

export interface ISalableItem {
    SalableItemID?: number,
    ProductID?: number,
    Price?: number,
    BarCode?: string,
    ExtraDesc?: string,
    WarrantyTypeID?: number,
    FeaturedStat?: number,
    Quantity?: number,
    DatePublishEndJalali?: string,
    DatePublishStartJalali?: string,
    SalableItemOptionIds?: number[]
}

export interface IWarrantyItem {
    VendorID?: number,
    WarrantyTypeID: number,
    ProductTypeID?: number,
    WarantyMonth: number,
    Title: string,
    Description: string,
    CreateDate?: string,
    ProductTypeName?: string,
    CategoryID?: number,
    CategoryName?: string,
    IsDefault: boolean
}

export interface IWarrantyModel {
    LstendorWarrantyTypeDefine: IWarrantyItem[],
    DefaultWarrantyTypeID: number
}

export interface IWarrantyParams {
    ID: number;
    TypeID: number;
}


export interface ICity {
    C: number;
    CN: string;
    CountryID: number;
    P: number
}

export interface IProvince {
    P: number;
    PN: string;
}

export interface IGetCityModel {
    Cities: ICity[];
    Provinces: IProvince[];
}
export interface IOrdersParams {
    RowsPerPage: number
    PageNumber: number
}
export interface IOrdersData {
    showWaiting: boolean,
    showApproved: boolean,
    showPackAndShipping: boolean,
    showDelivered: boolean,
    showReturned: boolean,
    showCanceled: boolean
}
export interface IOrdersItem {
    PaymentStatus: number;
    DeliveryStatus: number;
    ID: string;
}

export interface IChangePaymentData {
    OrderID: string;
    OperatorDescription: string;
    PaymentStatus: number;
}
export interface IChangeDeliveryData {
    OrderID: string;
    OperatorDescription: string;
    DeliveryStatus: number;
}

export interface ITransportItem {
    VendorID?: number;
    TransportTypeID: number;
    TransportTypeName: string;
    ProductTypeID?: number;
    DelayHours: number;
    Provinces_ReadOnly: IProvince[];
    Description: string;
    Price: number;
    Cities: ICity[];
    CreateDate?: string;
    ProductTypeName?: string;
    CategoryID?: number;
    IsDefault: boolean;
    CategoryName?: string;
    ProductPackagingType: number
}

export interface IChangePriceModel {
    Type: number,
    ID: number,
    Price: number,
    IsPercentage: boolean,
    IsIncrease: boolean,
    RoundingRate: number,
    IsCeiling: boolean
}

export interface ITransportModel {
    LstendorTransportTypeDefine: ITransportItem[],
    DefaultTransportTypeID: number
}

export interface ICommisionData {
    TableID: number,
    TableType: number,
    CommisionPrice?: number,
}

export interface ITransportParams {
    ID: number;
    TypeID: number;
}
export interface ISettingModulePath {
    StoreCarouselList: string;
    StoreCart: string;
    StoreCheckout: string;
    StoreCompare: string;
    StoreCustomList: string;
    StoreListByCat: string;
    StoreListByCatFilter: string;
    StoreListByType: string;
    StoreListByTypeFilter: string;
    StoreMiniCart: string;
    StoreProductDetail: string;
    StoreSearch: string;
    StoreSearchResult: string;
    StoreVendorProductList: string;
    StoreVendorProductListFilter: string
}
export enum NodeType {
    Category = 1,
    ProductType,
    Manufacturer,
    Product
}


export interface ITreeResource extends ng.resource.IResourceClass<ITreeResource> {
    publish(params: IPublishSendParams, success?: Function, error?: Function): IPublishParameters;
    getProgress(params: IgetProgressSendParams, success?: Function, error?: Function): IPublishParameters;
}

export interface IWarrantyResource extends ng.resource.IResourceClass<IWarrantyResource> {
    // get(params: IWarrantyParams, success ? : Function, error ? : Function)
}
export interface ITransportResource extends ng.resource.IResourceClass<ITransportResource> {
    // get(params: IWarrantyParams, success ? : Function, error ? : Function)
}

export interface IVendorTreeResource extends ITreeResource {
    getProduct(params: ITreeNodeSendParams, success?: Function, error?: Function)
}

export interface ISalableItemResource extends ng.resource.IResourceClass<ISalableItemResource> {
    getOptions(params: {
        ProductID: number
    }, success?: Function, error?: Function);
    getWarranty(params: IWarrantyParams, success?: Function, error?: Function);

}

export interface ICityResource extends ng.resource.IResourceClass<IGetCityModel> {

}
export interface IOrdersResource extends ng.resource.IResource<IOrdersResource> {

    PaymentStatus: number;
    ID: string;
    DeliveryStatus: number;
    query(params: IOrdersParams, data: IOrdersData, success?: Function, error?: Function): IOrdersResource[]
    bill(params: {}, data: {}, success?: Function, error?: Function)
    changePayment(data: IChangePaymentData, success?: Function, error?: Function)
    changeDelivery(data: IChangeDeliveryData, success?: Function, error?: Function)

}
export interface ICommisionResource extends ng.resource.IResource<ICommisionResource> {
    TableID: number,
    TableType: number,
    CommisionPrice: number,
    remove(data: ICommisionData, success?: Function, error?: Function);
    save(data: ICommisionData, success?: Function, error?: Function);
}

export interface IChangePriceResource extends ng.resource.IResource<IChangePriceResource> {
    save(data: IChangePriceModel, success?: Function, error?: Function);
}

export interface IVendorResource extends ng.resource.IResourceClass<IVendorResource> {

}

export function GetAllSubNode($resource: ng.resource.IResourceService, MyConstant) {
    "ngInject"

    return $resource<ITreeResource>(`${MyConstant.ApiUrl}ProductManagement/GetNodebyVendorID/?TypeID=:TypeID&id=:ID&PageSize=:PageSize&PageNumber=:PageNumber`, {
        TypeID: '@TypeID',
        id: '@ID'
    }, {
            publish: {
                method: 'POST',
                url: `${MyConstant.ApiUrl}ProductManagement/SaveProductByEntityID`,
            },
            getProgress: {
                method: 'GET',
                url: `${MyConstant.ApiUrl}ProductManagement/GetPercentage/?progressID=:Guid`,
            }
        })
}


export function GetAllVendorSubNode($resource: ng.resource.IResourceService, MyConstant) {

    "ngInject"
    return $resource<IVendorTreeResource>(`${MyConstant.ApiUrl}SalableItemManagement/GetNode/?TypeID=:TypeID&id=:ID`, null, {
        'getProduct': {
            method: 'GET',
            url: `${MyConstant.ApiUrl}SalableItemManagement/GetNodeByManufacturer/?TypeID=:TypeID&id=:ID`,
            // isArray:true,
        }
    })
}


export function SalableItems($resource: ng.resource.IResourceService, MyConstant) {
    "ngInject"
    return $resource<ITreeResource>(`${MyConstant.ApiUrl}SalableItemManagement/GetSalableItem/?ProductID=:ProductID`, null, {
        'getOptions': {
            method: 'GET',
            url: `${MyConstant.ApiUrl}SalableItemManagement/GetProductOptions/?ProductID=:ProductID`,
            isArray: true
        },
        'remove': {
            method: 'GET',
            url: `${MyConstant.ApiUrl}SalableItemManagement/RemoveSalableItem/?SalableItemID=:SalableItemID`,
        },
        'save': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}SalableItemManagement/SaveSalableItem`,
            isArray: true,

        },
        'getWarranty': {
            method: 'GET',
            url: `${MyConstant.ApiUrl}SalableItemManagement/GetWarrantyType/?TypeID=:TypeID&ID=:ID`,
            isArray: true,
            // transformResponse:{function(data){
            //     return {data:data}
            // }}
        },
        'getOne': {
            url: `${MyConstant.ApiUrl}SalableItemManagement/GetSalableItemBySalableItemId?SalableItemId=:salableItemId`
        },
        'saveOne': {
            url: `${MyConstant.ApiUrl}SalableItemManagement/SaveSalableItemOneItem`,
            method: 'POST'
        }

    })
}


export function WarrantyType($resource: ng.resource.IResourceService, MyConstant) {
    "ngInject"
    return $resource<IWarrantyResource>(`${MyConstant.ApiUrl}SalableItemManagement/GetWarrantyType/?TypeID=:TypeID&ID=:ID`, null, {
        'remove': {
            method: 'GET',
            url: `${MyConstant.ApiUrl}SalableItemManagement/RemoveWarrantyType/?warrantyTypeID=:WarrantyTypeID&vendorId=:vendorId`,
        },
        'save': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}SalableItemManagement/SaveWarrantyType/?TypeID=:TypeID&ID=:ID`,
            // isArray: true,
        },
        getOne: {
            method: 'GET',
            url: `${MyConstant.ApiUrl}WarrantyManagement/Get?VendorId=:vendorId&warrantyTypeID=:warrantyTypeId`,
        },
        saveOne: {
            method: 'POST',
            url: `${MyConstant.ApiUrl}WarrantyManagement/Save`,
        },
        removeOne: {
            method: 'GET',
            url: `${MyConstant.ApiUrl}WarrantyManagement/Remove?VendorId=:vendorId&warrantyTypeID=:warrantyTypeId`,
        }
    })
    
    
}


export function TransportType($resource: ng.resource.IResourceService, MyConstant) {
    "ngInject"
    return $resource<ITransportResource>(`${MyConstant.ApiUrl}ShipmentProductAssignment/GetShipmentProductAssignmentsByParameters/?productID=:ID`, null, {
        'remove': {
            method: 'GET',
            url: `${MyConstant.ApiUrl}SalableItemManagement/RemoveTransportType/?TransportTypeID=:TransportTypeID`,
        },
        'save': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}SalableItemManagement/SaveTransportType/?TypeID=:TypeID&ID=:ID`,
            // isArray: true,

        }
    })

}


export function Orders($resource: ng.resource.IResourceService, MyConstant) {
    "ngInject"
    return $resource<IOrdersResource>(`${MyConstant.ApiUrl}ECBOrderManagement/GetOrdersByFilter/?RowsPerPage=:RowsPerPage&PageNumber=:PageNumber`, null, {
        'get': {
            method: 'GET',
            url: `${MyConstant.ApiUrl}ECBOrderManagement/GetOrder/?OrderID=:OrderID`,
            params: {
                OrderID: '@ID'
            }
        },
        'bill': {
            url: `${MyConstant.ApiUrl}ECBOrderManagement/GetOrderBill/?orderId=:orderId`
        },
        'query': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}ECBOrderManagement/GetOrdersByFilter/?RowsPerPage=:RowsPerPage&PageNumber=:PageNumber`,
            isArray: true
        },
        'changePayment': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}ECBOrderManagement/ChangePaymentStatus`,
        },
        'changeDelivery': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}ECBOrderManagement/ChangeDeliveryStatus`,
        }
    })
}


export function GetCity($resource: ng.resource.IResourceService, MyConstant) {
    "ngInject"
    return $resource<ICityResource>(`${MyConstant.ApiUrl}ECBTempGeneral/getcities`, null, {})
}


export function CommisionPrice($resource: ng.resource.IResourceService, MyConstant) {
    "ngInject"
    return $resource<ICityResource>(`${MyConstant.ApiUrl}ProductCommision/SaveCommision`, null, {
        'remove': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}SalableCommision/RemoveCommision`,
        },
        'save': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}SalableCommision/SaveCommision`,
        }
    })
}


export function changePrice($resource: ng.resource.IResourceService, MyConstant) {
    "ngInject"
    return $resource<ICityResource>(`${MyConstant.ApiUrl}SalableChangePrice/ChangePrice`, null, {
        'save': {
            method: 'POST',
        }
    })
}


export function getSetting($http, MyConstant) {
    "ngInject"
    return {
        get: function () {
            var req = {
                method: 'GET',
                url: `${MyConstant.ApiUrl}/Settings/GetSettings`,
            }
            return $http(req, { cache: true });
        }
    }
}


export function VendorInfo($resource: ng.resource.IResourceService, MyConstant) {
    "ngInject"
    return $resource<IVendorResource>(`${MyConstant.ApiUrl}ECBTempGeneralSetting/GetVendorInfo`, null, {
    })
}

export function Category($resource, MyConstant) {
    "ngInject"
    return $resource(`${MyConstant.ApiUrl}DataEntry_Category/GetTree_Category`, {}, {
        All: {
            method: 'GET',
            url: `${MyConstant.ApiUrl}DataEntry_Category/GetTree_Category`
        },
        save: {
            method: 'POST',
            url: `${MyConstant.ApiUrl}DataEntry_Category/SaveCategory`
        },
        remove: {
            method: 'get',
            url: `${MyConstant.ApiUrl}DataEntry_Category/RemoveCategory?categoryID=:categoryID`
        },
        get: {
            method: 'get',
            url: `${MyConstant.ApiUrl}DataEntry_Category/GetCategory?categoryID=:categoryID`
        },
        query: {
            isArray: false,
            url: `${MyConstant.ApiUrl}Product/categories`,
            params: { PageNumber: '@PageNumber', PageSize: '@PageSize', Filters: '@Filters' }
        }
    })
}


export function ProductType($resource, MyConstant) {
    "ngInject"
    return $resource(`${MyConstant.ApiUrl}DataEntry_ProductType/GetProductType?productTypeID=:productTypeID `, null, {
        'save': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}DataEntry_ProductType/SaveProductType`,
            transformResponse: function (data, header) {
                var obj = { ProductTypeID: null };
                obj.ProductTypeID = angular.fromJson(data);
                return obj;
            },
        },
        'remove': {
            url: `${MyConstant.ApiUrl}DataEntry_ProductType/RemoveProductType?productTypeID=:productTypeID`
        },
        'getAllAttr': {
            url: `${MyConstant.ApiUrl}DataEntry_AttributeDefine/GetAttributeDefineByProductTypeID?productTypeID=:productTypeID`,
            isArray: true
        },
        'getAllAcceptable': {
            url: `${MyConstant.ApiUrl}DataEntry_AttributeAcceptableValues/GetAttributeAcceptableValuesByAttributeDefID?attributeDefID=:attributeDefID`,
            isArray: true
        },
        'saveAttr': {
            url: `${MyConstant.ApiUrl}DataEntry_AttributeDefine/SaveAttributeDefine`,
            method: 'POST',
            transformResponse: function (data, header) {
                var obj = { AttributeDefID: null };
                obj.AttributeDefID = angular.fromJson(data);
                return obj;
            },

        },
        'removeAttr': {
            url: `${MyConstant.ApiUrl}DataEntry_AttributeDefine/RemoveAttributeDefine?attributeDefineID=:attributeDefineID`,
        },
        'saveAcceptable': {
            url: `${MyConstant.ApiUrl}DataEntry_AttributeAcceptableValues/SaveAttributeAcceptableValues`,
            method: 'POST',
            transformResponse: function (data, header) {
                var obj = { AttributeAcceptableValuesID: null };
                obj.AttributeAcceptableValuesID = angular.fromJson(data);
                return obj;
            },
        },
        'removeAcceptable': {
            url: `${MyConstant.ApiUrl}DataEntry_AttributeAcceptableValues/RemoveAttributeAcceptableValues?attributeAcceptableValuesID=:attributeAcceptableValuesID`,
        },
        'getAllGroup': {
            url: `${MyConstant.ApiUrl}DataEntry_AttributeGroup/GetAllAttributeGroupName`,
            isArray: true
        },
        'query': {
            isArray: false,
            url: `${MyConstant.ApiUrl}Product/productTypes`,
            params: { PageNumber: '@PageNumber', PageSize: '@PageSize', Filters: '@Filters' }
        }
    })
}

export function Manufacturer($resource, MyConstant) {
    "ngInject"
    return $resource(`${MyConstant.ApiUrl}DataEntry_Manufacturer/GetManufacturer?manufacturerID=:manufacturerID`, null, {
        'save': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}DataEntry_Manufacturer/SaveManufacturer`
        },
        'remove': {
            url: `${MyConstant.ApiUrl}DataEntry_Manufacturer/RemoveManufacturer?manufacturerID=:manufacturerID`
        },
        'getAllParent': {
            url: `${MyConstant.ApiUrl}DataEntry_ProductType/GetAllProductTypeAsTreeNode`,
            isArray: true
        }
    })
}



export function Product($resource, MyConstant) {
    "ngInject"
    return $resource(`${MyConstant.ApiUrl}DataEntry_Product/GetProduct?ProductID=:ProductID`, null, {
        'GetManufacturer': {
            url: `${MyConstant.ApiUrl}DataEntry_Manufacturer/GetManufacturerList?ProductTypeID=:ProductTypeID`,
            isArray: true
        },
        'getAllAttr': {
            url: `${MyConstant.ApiUrl}DataEntry_ProductAttributeValues/GetProductAttributeValuesList?ProductID=:ProductID`,
            isArray: false
        },
        'saveAttr': {
            url: `${MyConstant.ApiUrl}DataEntry_ProductAttributeValues/SaveProductAttributeValuesList`,
            method: 'POST'
        },
        'save': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}DataEntry_Product/SaveProduct`,
            transformResponse: function (data, header) {
                var obj = { ProductID: null };
                obj.ProductID = angular.fromJson(data);
                return obj;
            },
        },
        'remove': {
            url: `${MyConstant.ApiUrl}DataEntry_Product/RemoveProduct?ProductID=:ProductID`
        },
        'removeImage': {
            url: `${MyConstant.ApiUrl}DataEntry_Product/RemoveProductImage?ProductID=:ProductID`
        },
        'query': {
            isArray: false,
            url: `${MyConstant.ApiUrl}Product/products`,
            params: { PageNumber: '@PageNumber', PageSize: '@PageSize', Filters: '@Filters' }
        }
    })
}


export enum sortNodeType {
    Category = 1,
    ProductType = 2,
    Manufacturer = 3,
    Product = 4,
    Attribute = 5,
    AttributeAcceptable = 6
}


export function SortingListService($resource, MyConstant) {
    "ngInject"
    return $resource(`${MyConstant.ApiUrl}ProductManagement/GetGeneralSortedItems/?listType=:listType&keyType=:keyType&key=:key`, {}, {
        'save': {
            method: 'POST',
            url: `${MyConstant.ApiUrl}ProductManagement/SaveGeneralSortedItems/?listType=:listType`
        },

    })
}


// WEBPACK FOOTER //
// ./src/store-modules/management/vendorAdmin.service.ts